"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInstanceOf = void 0;
/** Validator that only allows instances of the given parent. */

var isInstanceOf = function isInstanceOf(parent) {
  return function (value) {
    if (!(value instanceof parent)) {
      return "value should be an instance of ".concat(parent.name);
    }

    return undefined;
  };
};

exports.isInstanceOf = isInstanceOf;